export interface BlockchainEvent {
  type: "token_created" | "trade_executed" | "vote_cast" | "pool_updated" | "connection_status" | "connection_failed";
  data: any;
  signature: string;
  timestamp: number;
}

export class BlockchainEventMonitor {
  private eventCounts: Map<string, number> = new Map();
  private lastEventTime: Map<string, number> = new Map();

  logEvent(event: BlockchainEvent) {
    const count = this.eventCounts.get(event.type) || 0;
    this.eventCounts.set(event.type, count + 1);
    this.lastEventTime.set(event.type, Date.now());

    console.log(`[Blockchain Event] ${event.type}:`, {
      data: event.data,
      signature: event.signature,
      timestamp: new Date(event.timestamp).toISOString(),
      totalCount: count + 1,
    });
  }

  getStats() {
    return {
      eventCounts: Object.fromEntries(this.eventCounts),
      lastEventTimes: Object.fromEntries(this.lastEventTime),
    };
  }
}